
import dayjs from 'dayjs';



const dateTimeFormat = (dateTimeString, format="YYYY/M/D HH:mm") => {
  if (!dateTimeString) {
    return dateTimeString;
  }
  return dayjs(dateTimeString).format(format);
}

const convertMomentFieldToString = (object, format="YYYY-MM-DD HH:mm:ss") => {
  if (!object) {
    return object;
  }
  const convertted = {...object};
  Object.keys(object).filter(k => dayjs.isDayjs(object[k])).forEach(k => convertted[k] = object[k].format(format));
  return convertted;
}

function formatDuration(duration) {
    if (duration == null || duration <= 0) {
        return '-';
    }

    const hours = Math.floor(duration / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((duration % 3600) / 60).toString().padStart(2, '0');
    const seconds = (duration % 60).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}

function formatLastActionTimeText(lastTimeStr) {
    let nowTime = dayjs();
    const lastTime = dayjs(lastTimeStr);
    let diff = nowTime.diff(lastTime, 'second');
    if (diff == null || diff <= 0) {
        return '';
    }
    const days = Math.floor(diff / 86400);
    if (days > 0) {
        let years = nowTime.year() - lastTime.year();
        if (years > 0) {
            return `${years}年前`;
        }
        let months = nowTime.month() + nowTime.year() * 12 - lastTime.month() - lastTime.year() * 12;
        if (months > 0) {
            return `${months}个月前`;
        }
        if (days > 7) {
            return `${Math.floor(days/7)}周前`;
        }
        return `${days}天前`;
    }
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    if (hours > 0) {
        return `${hours}小时前`;
    }
    if (minutes > 0) {
        return `${minutes}分钟前`;
    }
    if (seconds > 0) {
        return `${seconds}秒前`;
    }
    return '现在';
}


const dateFormat = "YYYY-MM-DD";
const timeFormat = "YYYY-MM-DD HH:mm";
function formatDate(date) {
  if (!date) {
    return '';
  }
  return dayjs(date).format(dateFormat)
}

function formatTime(time) {
  if (!time) {
    return '';
  }
  return dayjs(time).format(timeFormat)
}


const isWechat = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') > -1;
  //return true;
}

function debounce(fn, wait) {
  let callback = fn;    
  let timerId = null;

  function debounced() {
      // 保存作用域
      let context = this;
      // 保存参数，例如 event 对象
      let args = arguments;        

      clearTimeout(timerId);        
      timerId = setTimeout(function() {            
          callback.apply(context, args);
      }, wait);
  }
  
  // 返回一个闭包
  return debounced;         
}

// 空值安全
const $ = maybeNull => maybeNull || {};

const chnNumChar = { 零:0, 一:1, 二:2, 三:3, 四:4, 五:5, 六:6, 七:7, 八:8, 九:9 };
const chnNameValue = {十:{value:10, secUnit:false}, 百:{value:100, secUnit:false}, 千:{value:1000, secUnit:false}}
const chineseToNumber = (chnStr) => {
  let rtn = 0;
  let section = 0;
  let number = 0;
  let secUnit = false;
  const str = chnStr.split('');

  for(let i = 0; i < str.length; i++){
    const num = chnNumChar[str[i]];
      if(typeof num !== 'undefined'){
          number = num;
          if(i === str.length - 1){
              section += number;
          }
      } else{
        const unit = chnNameValue[str[i]].value;
          secUnit = chnNameValue[str[i]].secUnit;
          if(secUnit){
              section = (section + number) * unit;
              rtn += section;
              section = 0;
          }else{
              section += (number * unit);
          }
          number = 0;
      }
  }
  return rtn + section;
}


const hasPermission = (globalData,keyId) => {
 
  const user = globalData.user;
  //console.log("------", user);
  const { permissions = [] } = user || {};
  const permissionKeys = permissions && permissions.filter(item => item.type == 'LINK').map(item => item.value);
  //  console.log("权限列表",permissionKeys,keyId)
  return permissionKeys.includes(keyId);
}



function isVaginalDelivery(fetalDeliveryMode) {
  return fetalDeliveryMode === '顺产' || fetalDeliveryMode === '吸引产' || fetalDeliveryMode === '臀助产' || fetalDeliveryMode === '臀牵引' || fetalDeliveryMode === '钳产';
}

function isCesareanDelivery(fetalDeliveryMode) {
  return fetalDeliveryMode && fetalDeliveryMode.substring(0, 3) === '剖宫产';
}

function filterSpecialCharacters(text) {
  if (!text) {
    return '';
  }
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export {dateTimeFormat, formatDuration, formatLastActionTimeText, formatDate,formatTime, $, convertMomentFieldToString, debounce, chineseToNumber, isWechat, hasPermission,
  isVaginalDelivery, isCesareanDelivery, filterSpecialCharacters}